
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Aggiungilo alla schermata principale per un'esperienza più completa e un accesso facile.`,
's224cbcec014ef6b5': `Premi Condividi nella barra di navigazione`,
's37a9e8aec5713460': `Più`,
's386eca8362ff6155': `Premi Altro se non c'è l'icona Condividi`,
's4e1e10a6ca408245': `Tocca "Aggiungi alla schermata principale"`,
's6196153c4b0c1ea0': `Installa`,
's633502f7cff4f847': `Apri il menu del tuo browser`,
's681e399d63311fba': `Mostra galleria`,
's7f0591f08e318eda': `Premi Altro nel menu Condividi`,
's8114bd55cae5a22b': `Premi Aggiungi al Dock`,
's922329d6f6213590': `Aggiungi al Dock`,
's9af56bf005b49c74': `Scorri verso il basso fino a "Aggiungi alla schermata principale"`,
'sa5ef80b4bb9b39f8': `Meno`,
'sba52286c21552a4e': `Installalo sul tuo dispositivo per un'esperienza più completa e un accesso facile.`,
'sc16e00a7a8b2fde2': `Indietro`,
'scdaf4bbff76674c8': `Aggiungi alla schermata principale`,
'se0e473adfda8066c': `Apri nel tuo browser principale`,
'se740f75b95a51807': `Aggiungilo al Dock per un'esperienza più completa e un accesso facile.`,
'sfea652f6580ff086': `Questo sito ha funzionalità di app.`,
    };
  